import { render, staticRenderFns } from "./DriverInvoices.vue?vue&type=template&id=48022bd5&"
import script from "./DriverInvoices.vue?vue&type=script&lang=js&"
export * from "./DriverInvoices.vue?vue&type=script&lang=js&"
import style0 from "./DriverInvoices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports